// ZIP-code checker for the "Where we deliver" footer accordion.
// Rendered by snippets/delivery-zones.liquid, which also embeds the covered ZIPs
// as JSON so the checker and the visible lists can never drift apart.

const PHONE = '(929) 752-4444';

function initSection(section) {
  const form = section.querySelector('[data-delivery-check]');
  const json = section.querySelector('[data-delivery-zips]');
  if (!form || !json || form.dataset.bound === 'true') return;

  let zips;
  try {
    zips = new Set(JSON.parse(json.textContent));
  } catch (error) {
    // The visible borough lists are server-rendered, so a JSON failure degrades
    // to "no live checker" rather than breaking the accordion.
    return;
  }
  if (zips.size === 0) return;

  form.dataset.bound = 'true';

  const input = form.querySelector('.delivzone__input');
  const result = form.querySelector('.delivzone__result');
  if (!input || !result) return;

  const report = (state, message) => {
    if (state) {
      result.dataset.state = state;
    } else {
      delete result.dataset.state;
    }
    result.textContent = message;
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const value = input.value.trim();

    if (!/^\d{5}$/.test(value)) {
      report('invalid', 'Enter a 5-digit ZIP code.');
      return;
    }

    if (zips.has(value)) {
      report('yes', `Yes — we deliver to ${value}. Order by 2:00 PM for same-day delivery.`);
    } else {
      report('no', `${value} is outside our same-day zone. Call ${PHONE} — we may still be able to help.`);
    }
  });

  // Clear a stale verdict as soon as the buyer edits the field.
  input.addEventListener('input', () => {
    if (result.textContent) report('', '');
  });
}

document.querySelectorAll('.delivzone').forEach(initSection);
